import React from 'react';
import { Box, Text, Stack, ScrollArea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Icon, ICONS } from '@/common/components/Icon';

interface ChatSession {
    id: string;
    title: string;
    date: Date;
    preview: string;
}

interface ChatLeftSectionProps {
    sessions?: ChatSession[];
    onSelectSession?: (sessionId: string) => void;
    style?: React.CSSProperties;
    isCollapsed?: boolean;
    onToggleCollapse?: () => void;
}

const ChatLeftSection: React.FC<ChatLeftSectionProps> = ({ 
    
        sessions = [],
    onSelectSession = (id: string) => {
        // 기본 핸들러 동작, 빈 함수 대신 주석을 포함하여 린트 에러 방지
        console.log(`Session ${id} selected, but no handler provided`);
    },
        style,
        isCollapsed = false,
    onToggleCollapse = () => console.log('Toggle collapse handler not provided')
}) => {
    const { t } = useTranslation('ai');
    // 샘플 데이터
    const demoSessions: ChatSession[] = [

    ];
    
    const displaySessions = sessions.length > 0 ? sessions : demoSessions;
    
    // 접힌 상태일 때 빈 컨테이너만 표시
    if (isCollapsed) {
        return (
            <Box 
                style={{ 
                    width: '100%', 
                    height: '100%', 
                    backgroundColor: '#f8f9fa',
                    position: 'relative',
                    ...style 
                }}
            />
        );
    }
    
    // 펼쳐진 상태일 때 기존 형태로 표시
    return (
        <Box style={{ 
            width: '100%', 
            padding: '10px', 
            backgroundColor: '#f8f9fa', 
            height: '100%',
            position: 'relative',
            borderBottomLeftRadius: '16px',
            display: 'flex',
            flexDirection: 'column',
            ...style 
        }}>
            <ScrollArea style={{ 
                height: 'calc(100% - 30px)',
                flex: 1,
                position: 'relative',
            }}>
                <Stack gap="xs">
                    {displaySessions.map((session) => (
                        <Box 
                            key={session.id}
                            p="xs" 
                            style={{ 
                                border: '1px solid #eaeaea', 
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                            onClick={() => onSelectSession(session.id)}
                        >
                            <Text fw={500} size="sm" truncate>{session.title}</Text>
                            <Text size="xs" c="dimmed" mb="xs">
                                {session.date.toLocaleDateString()}
                            </Text>
                            <Text size="xs" lineClamp={2}>
                                {session.preview}
                            </Text>
                        </Box>
                    ))}
                    
                    <Text my="xs" fw={400} size="14px" c="dimmed" pl="xs">{t('chat.history')}</Text>
                    
                </Stack>
            </ScrollArea>
            
            {/* 강아지 발자국 아이콘 */}
            <Box style={{ 
                position: 'absolute',
                bottom: '0px',
                left: '20px',
                lineHeight: 0,
                padding: 0,
                fontSize: 0,
            }}>
                <Icon name={ICONS.AI.LAIKA_FOOTPRINT} />
            </Box>
        </Box>
    );
};

export default ChatLeftSection; 